import { render, staticRenderFns } from "./Unitdetails.vue?vue&type=template&id=34762cbd&scoped=true"
import script from "./Unitdetails.vue?vue&type=script&lang=js"
export * from "./Unitdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34762cbd",
  null
  
)

export default component.exports